import { render, staticRenderFns } from "./cPagination.vue?vue&type=template&id=607f7a8a&scoped=true"
import script from "./cPagination.vue?vue&type=script&lang=js"
export * from "./cPagination.vue?vue&type=script&lang=js"
import style0 from "./cPagination.vue?vue&type=style&index=0&id=607f7a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607f7a8a",
  null
  
)

export default component.exports